import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { GetCareNowFormatService } from '../../../get-care-now-feature/utilities/getcarenow-format.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { PostGetProviderDetailsRequest } from '../../../shared/model/providerlocationsearch/PostGetProviderDetailRequest';
import { MCAppGatewayService } from '../../../shared/services/mcappgateway/mcappgateway.service';
import { SearchStateService } from '../../shared/services/search-state.service';
import { MonitoringService } from '../../../shared/services/monitoring/monitoring-service';

@Component({
  selector: 'app-location-search-details-provider-card',
  imports: [CommonModule], // Uncomment if using standalone
  templateUrl: './location-search-details-provider-card.component.html',
  styleUrl: './location-search-details-provider-card.component.css'
})
export class LocationSearchDetailsProviderCardComponent {
  mcAppGateway = inject(MCAppGatewayService);
  searchState = inject(SearchStateService);

  @Input() provider: any;
  @Input() currentLocation: any = null;
  @Input() fromProviderSearch: boolean = false;

  eptID: any = null;

  public soonAsText: string = 'AS_SOON_AS';
  public milesAwayText: string = 'DESCRIPTION';
  public scheduleText: string = 'SCHEULE';
  public today: string = 'TODAY';
  public tomorrow : string = 'TOMORROW';
  public getDirectionsLabel : string = 'GET_DIRECTIONS';
  public viewProfileBtnText: string = 'NO_AVAILABILITY';  
  public waitTime: string = '';
   
  private getCareNowFormatService: GetCareNowFormatService;
  
  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(sessionStorage.getItem('locale') || 'en-US'); // Default to 'en-US' if no locale is provided
    this.eptID = sessionStorage.getItem('eptID');
    this.getCareNowFormatService = new GetCareNowFormatService(this.translate);
  }
  
  ngOnInit(): void {
      this.waitTime = this.getCareNowFormatService.formatNextAvailability(this.provider.nextAvailability);
  
      this.translate.get('BOOK_AS_SOON_AS').subscribe((translated: string) => {
        this.soonAsText = translated;
      });
  
      this.translate.get('MILES_AWAY').subscribe((translated: string) => {
        this.milesAwayText = translated;
      });
  
      this.translate.get('SCHEDULE').subscribe((translated: string) => {
        this.scheduleText = translated;
      });

      this.translate.get('GET_DIRECTIONS').subscribe((translated: string) => {
        this.getDirectionsLabel = translated;
      });

      this.translate.get('VIEW_PROFILE').subscribe((translated: string) => {
        this.viewProfileBtnText = translated;
      });
  }

  scheduleAuth() {
    var deepLink = environment.web_scheduling_deep_link_base_url;
    deepLink += "?workflow=NewProvider"
 
    deepLink += "&selProvId=" + this.provider.providerEmrId;
    // deepLink += "&selRfvId=" + environment.office_visit_prc_id;
     
    if (this.provider.departmentId != null && this.provider.departmentId != '') {
      deepLink += "&selDepId=" + this.provider.departmentId;
    }
 
    if (this.provider.specialtyId != null && this.provider.specialtyId != '') {
      deepLink += "&selSpecialtyId=" + this.provider.specialtyId;
    }

    this.monitoringService.logEvent('Schedule', { feature: 'search', subfeature: 'provider-search', platform: 'web'}); // log as mobile or web event

    var searchMethod = sessionStorage.getItem('locationSearchMethod') ?? 'unknown';

    if (searchMethod === 'freeText') {
      deepLink += "&linksource=AUTHHMLOCFTDETSPC";
    }
    else if (searchMethod === 'quickSearch') {
      deepLink += "&linksource=AUTHHMLOCQSDETSPC";
    }

    window.location.href = deepLink;
  }

  scheduleUnauth() {
    var deepLink = environment.web_open_scheduling_deep_link_base_url;

    deepLink += "/standalone"; // Use standalone workflow for unauthenticated users)

    deepLink += "?id=" + this.provider.providerEmrId;
    // deepLink += "&vt=" + environment.office_visit_prc_id;

    if (this.provider.departmentId != null && this.provider.departmentId != '') {
      deepLink += "&dept=" + this.provider.departmentId;
    }
 
    if (this.provider.specialtyId != null && this.provider.specialtyId != '') {
      deepLink += "&specialty=" + this.provider.specialtyId;
    }

    if (this.fromProviderSearch == true) {
        deepLink += "&linksource=PLUAPROFLOCDETPROVCARD";
    }
    else { 
      var searchMethod = sessionStorage.getItem('locationSearchMethod') || 'unknown';

      if (searchMethod === 'freeText') {
        deepLink += "&linksource=PLUALOCFTVDSCHEDPROVCARD";
      }
      else if (searchMethod === 'quickSearch') {
        deepLink += "&linksource=PLUALOCQSVDSCHEDPROVCARD";
      }
        
    }

    this.monitoringService.logEvent('Schedule/NoAuth', { feature: 'search-care-now', subfeature: 'provider', platform: 'web'}); // log as mobile or web event
      
    window.location.href = deepLink;
  }
  
  onScheduleButtonClicked() {
    if (this.provider && this.provider.providerEmrId && this.provider.providerEmrId.length > 0) {
      if (this.eptID != null && this.eptID != '') {
        this.scheduleAuth();
      }
      else {
        this.scheduleUnauth();
      }
    }
  }
  
  onGetDirections() {
    if (this.provider && this.provider.locationDirection) {
      window.open(this.provider.locationDirection, '_blank');
    }
  }

  onViewDetails() {
    console.log('Viewing details for provider:', this.provider);

    // Implement the logic to view provider details here
    this.searchState.setCurrentLocationDetailsProvider(this.provider);   
    this.searchState.setShowSpinner(true);
    
    var providerDetailsRequest = new PostGetProviderDetailsRequest();
    providerDetailsRequest.providerID = this.provider.providerId;
    providerDetailsRequest.latitude = this.currentLocation?.latitude || null;
    providerDetailsRequest.longitude = this.currentLocation?.longitude || null;

    this.mcAppGateway.PostGetProviderDetails(providerDetailsRequest).subscribe({
      next: (response) => {
        console.log('Provider Details Response:', response);
        
        // Handle the response as needed
        this.searchState.setCurrentProviderDetails(response);
        this.searchState.setShowSpinner(false);
      },
      error: (error) => {
        console.error('Error fetching provider details:', error);
        alert('An error occurred while fetching provider details. Please try again later.');
        this.searchState.setShowSpinner(false);
        this.searchState.clearCurrentProviderDetails();
      }
    });
  }
}